export const POPUP_CLASSES = {
  COLOR_PALETTE: 'form-theme-custom-color-palette',
  COLOR_PICKER: 'form-theme-custom-color-picker'
} as const;

/**
 * @param kendoButtonRef - Reference to the hidden Kendo button element
 * @param popupClassName - CSS class name of the popup to check if open
 */
export const toggleColorPickerPopup = (
  kendoButtonRef: HTMLButtonElement | null,
  popupClassName: string
): void => {
  if (!kendoButtonRef) return;

  const popup = document.querySelector(`.${popupClassName}`);

  if (popup) {
    document.dispatchEvent(new KeyboardEvent('keydown'));
  } else {
    kendoButtonRef.click();
  }
};
